export function jsonToFormData(
  body: object,
  formData: FormData = new FormData(),
  parentKey = '',
): FormData {
  Object.entries(body).forEach(([key, value]) =>
    appendValue(`${parentKey}${key}`, value, formData),
  );
  return formData;
}

function appendValue(key: string, value: unknown, formData: FormData) {
  if (value === undefined) return;
  if (value === null) {
    formData.set(key, '');
    return;
  }
  if (value instanceof File) {
    formData.set(key, value);
    return;
  }
  if (Array.isArray(value)) {
    if (value.length === 0) {
      formData.set(key, '');
      return;
    }
    value.forEach((item, i) => appendValue(`${key}[${i}]`, item, formData));
    return;
  }
  if (typeof value === 'object') {
    jsonToFormData(value, formData, key);
    return;
  }
  formData.set(key, String(value));
}
